import store from "../store/index";
import ApiHelpers from "../helpers/ApiHelpers";
import {
    FETCH_GENERATED_REPORTS_API

} from "../constants/urls";

export const reportsService = {
    fetchGeneratedReports
}

async function fetchGeneratedReports({ pageSize, nextPageToken, type, searchQuery }) {
    const queryParams = new URLSearchParams();

    queryParams.append("pageSize", pageSize);

    if (nextPageToken) queryParams.append("nextPageToken", nextPageToken);

    if (type) queryParams.append("type", type);

    if (searchQuery) queryParams.append("searchQuery", searchQuery);

    const response = await ApiHelpers.makeAPICall(
        `${store.state.appState.apiURL}${FETCH_GENERATED_REPORTS_API}?${queryParams.toString()}`,
        "GET",
        null,
        false
    );

    return await handleResponse(response);
}

async function handleResponse(response) {
    try {
        const text = await response.text();
        const body = text ? JSON.parse(text) : null;

        if (body?.status?.toLowerCase() === 'success') {
            return { reports: body.payload ?? [], nextPageToken: body.nextPageToken };
        } else {
            return Promise.reject(body.error || { message: 'Some error occured. '});
        }
    } catch (error) {
        return Promise.reject({ message: 'Some error occured. '})
    }
}